import { DateTime } from 'luxon';
import d3 from '@/assets/d3';

/* const API_URL = 'data/ufos_3000_geo.json'; */

export default {
  getUfos(API_URL) {
    return d3.json(API_URL)
      .then(data => data.features.map((feature) => {
        const newFeature = { ...feature };
        newFeature.properties.dateLuxon = DateTime.fromSQL(newFeature.properties.datetime);
        newFeature.properties.year = newFeature.properties.dateLuxon.year;
        newFeature.properties.weekday = newFeature.properties.dateLuxon.toJSDate().getDay();
        return newFeature;
      }));
  },
};
